/* eslint max-len: 0 */
export const messages = {
  page: {
    title: {
      id: 'ccdaOptions.Form.Page.Title',
      defaultMessage: 'View Your Health Summary',
    },
    tolabel: {
      id: 'ccdaOptions.Form.Label.To',
      defaultMessage: ' - to - ',
    },
    instruction: {
      id: 'ccdaOptions.Form.Page.Introduction',
      defaultMessage: 'Use the options below to change the date range of your health information summary.',
    },
    form: {
      label: {
        daterange: {
          id: 'ccdaOptions.Form.Label.DateRange',
          defaultMessage: 'Select a date range',
        },
        startDateHint: {
          id: 'ccdaOptions.Form.Label.StartDateHint',
          defaultMessage: 'Start date, use numbers to enter the date format as month/day/year',
        },
        endDateHint: {
          id: 'ccdaOptions.Form.Label.EndDateHint',
          defaultMessage: 'End date, use numbers to enter the date format as month/day/year',
        },
        clearStartDateHint: {
          id: 'ccdaOptions.Form.Label.ClearStartDateHint',
          defaultMessage: 'Click here to clear start date',
        },
        clearEndDateHint: {
          id: 'ccdaOptions.Form.Label.ClearEndDateHint',
          defaultMessage: 'Click here to clear end date',
        },
        visits: {
          id: 'ccdaOptions.Form.Label.Visits',
          defaultMessage: 'View one of your past visits',
        },
        noVisits: {
          id: 'ccdaOptions.Form.Label.NoVisits',
          defaultMessage: 'There are no available past visits.',
        },
        system: {
          id: 'ccdaOptions.Form.Label.System',
          defaultMessage: 'System',
        },
        systemHint: {
          id: 'ccdaOptions.Form.Label.SystemHint',
          defaultMessage: 'Select a health summary source',
        },
      },
      error: {
        dateRequired: {
          id: 'ccdaOptions.Form.Error.DateRequired',
          defaultMessage: 'Please provide a Start Date and End Date',
        },
        required: {
          id: 'ccdaOptions.Form.Error.Required',
          defaultMessage: 'Required',
        },
        visitPickRequired: {
          id: 'ccdaOptions.Form.Error.VisitPickRequired',
          defaultMessage: 'Please select a past visit',
        },
      },
      button: {
        update: {
          id: 'ccdaOptions.Form.Button.Update',
          defaultMessage: 'Update Summary',
        },
        cancel: {
          id: 'ccdaOptions.Form.Button.Cancel',
          defaultMessage: 'Cancel',
        },
      },
    },
  },
};
